/**
 * The app's spinner, replacing ion-spinner.
 *
 * One mark rather than ion-spinner's six named variants — "crescent", "dots",
 * "lines-sharp" and the rest were picked per call site with no rule behind
 * which meant what.
 */
export const Spinner: React.FC<{
  /** Pixel size of the ring. */
  size?: number;
  /** On a dark or camera surface, where the token ink disappears. */
  onDark?: boolean;
  className?: string;
}> = ({ size = 20, onDark, className = '' }) => (
  <span
    role="status"
    aria-label="Loading"
    data-testid="spinner"
    style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 10)) }}
    className={`inline-block animate-spin rounded-full ${
      onDark ? 'border-white/25 border-t-white' : 'border-divider border-t-primary'
    } ${className}`}
  />
);
